module.exports = "/_next/static/images/53a3bbb12b6cf64b1058456cb40a92f5-bubble-gum-woman-square@xs-1x.jpg";